/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * modules.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import module.
 */
import { smoothScrollTo } from "./smoothScrollTo";
import { scrollToTopBtn } from "./smoothScrollToTopBtn";
import { setDNavBtn } from "./setDNavBtn";
// import { setHeaderTransform } from "./setHeaderTransform";
import { setSlider } from "./setSlider";
import { setScrollTrigger } from "./setScrollTrigger";
import { tabSelecterHover, tabSelecterClick } from "./setTabSelecter";
import { setGsapFlip } from "./setGsapFlip";
import { setDrawerNavChildToggle } from "./setDrawerNavChildToggle";
import { movieModalThanks } from "./movieModalThanks";

/**
 * Do modules.
 */
function modules() {
	smoothScrollTo();
	scrollToTopBtn();
	setDNavBtn();
	setDrawerNavChildToggle();
	setScrollTrigger();
	tabSelecterClick();
	tabSelecterHover();
	setSlider();
	setGsapFlip();
	movieModalThanks();
}

export { modules };
